import { FavoriteDeliveryType } from '../types/checkout-info';
import { FavoriteAddressDetails } from '../types/favorite-address';
import { FAVORITE_DELIVERY_TYPE } from '../common/constants';

export const getElementVariant = (
  deliveryType: FavoriteDeliveryType,
  regionName: string,
  address: FavoriteAddressDetails | null,
) => {
  switch (deliveryType) {
    case FAVORITE_DELIVERY_TYPE.HOME_DELIVERY:
      return 'Адрес доставки';

    case FAVORITE_DELIVERY_TYPE.REGION:
      return regionName;

    case FAVORITE_DELIVERY_TYPE.PICKUP:
      return address?.storeName ?? '';

    case FAVORITE_DELIVERY_TYPE.PICKUP_POINT:
      return address?.pickupPointAddress ?? '';

    default:
      return '';
  }
};

export const DELIVERY_TYPE_ELEMENT_TEXT: Record<FavoriteDeliveryType, string> = {
  [FAVORITE_DELIVERY_TYPE.REGION]: 'Город, регион',
  [FAVORITE_DELIVERY_TYPE.PICKUP]: 'Магазин самовывоза',
  [FAVORITE_DELIVERY_TYPE.PICKUP_POINT]: 'Пункт выдачи',
  [FAVORITE_DELIVERY_TYPE.HOME_DELIVERY]: 'Адрес доставки',
};
